export enum DateFilter {
	TODAY = 'Today',
	YESTERDAY = 'Yesterday',
	LAST_7_DAYS = 'Last 7 Days',
	LAST_30_DAYS = 'Last 30 Days',
	LAST_90_DAYS = 'Last 90 Days',
	LAST_YEAR = 'Last Year',
	CUSTOM_RANGE = 'Custom range',
}

export interface QueryDateRange {
	start?: string;
	end?: string;
}
